import React from "react"
import skills from "./data";
import "./skills.css";

class Skills extends React.Component {
    render() {
        return (
            <div className={"skills"} id={"skills"}>
                <h1>Skills</h1>
                <h2>Languages</h2>
                <div>
                    {skills.languages.map(language => {
                        return <div key={language.name} className={"skill-chip"}><img
                            src={language.image}/> <p>{language.name}</p></div>
                    })}
                </div>
                <h2>Frameworks and Libraries</h2>
                {skills.frameWorks.map(language => {
                    return <div key={language.name} className={"skill-chip"}><img src={language.image}/> {language.name}
                    </div>
                })}
                <h2>Cloud Platform</h2>
                {skills.cloud.map(language => {
                    return <div key={language.name} className={"skill-chip"}><img src={language.image}/> {language.name}
                    </div>
                })}
                <h2>Databases</h2>
                {skills.databases.map(language => {
                    return <div key={language.name} className={"skill-chip"}><img src={language.image}/>{language.name}
                    </div>
                })}
                <h2>Other Technologies</h2>
                {skills.other.map(language => {
                    return <div key={language.name} className={"skill-chip"}><img src={language.image}/> {language.name}
                    </div>
                })}
            </div>
        );
    }
}

export default Skills;